import React from "react";
import 'react-datepicker/dist/react-datepicker.css'
import moment from "moment-timezone";
import NTMTable from "components/Table/NTMTable";
import CSVExporter from "components/Table/CSVExporter";


export default function Tables({ data, device }) {

	function getValue(field) {
		return field || field === 0 ? `${+field.toFixed(1)}` : "-"
	}

	let parameters = device?.configuration?.parameters ?? []
	parameters.sort((a, b) => a.name.localeCompare(b.name))

	const header = [
		{
			Header: "Orario",
			accessor: 'collectionDate',
			Cell: props => <div>{moment(props.original?.collectionDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm")}</div>
		},
		...parameters.map(p => ({
			Header: p.labelShort,
			accessor: p.name,
			Cell: props => <div>{`${getValue(props.original?.paramMap[p.name])} ${p.unit}`}</div>
		}))
	]

	function toCSVdata(data, parameters) {
		return data.map(d => {
			let datum = {
				Orario: moment(d.collectionDate).tz("Europe/Rome").format("DD/MM/YYYY HH:mm"),
				"Id dispositivo": d.deviceId,
			}
			// rietichetta i dati secodo le label dei parametri (va su intestazione file csv)
			parameters.forEach(p => {
				if (p.labelLong != null && p.name != null)
					datum[p.labelLong] = d.paramMap[p.name]
			});
			return datum;
		})
	}

	return (
		<div style={{ minHeight: 400, margin: "1rem auto" }}>
			<CSVExporter title={"Scarica"} name={"Agrismart"} data={toCSVdata(data, parameters)} />
			<NTMTable
				header={header}
				body={data}
				defaultPageSize={20}
			/>
		</div>
	)
}
